// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__1i4bZ","title":"PageHeader_title__nu8Bc","subtitle":"PageHeader_subtitle__GtHOs","actions":"PageHeader_actions__hp2Nq"};